import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
export function ProcessAction(encAction, res) {
  let url = `${Globals.baseUrl}/DocumentActions/ProcessAction`;
  console.log("processAction");
  console.log(res);
  axios.post(
    url,
    {
      encryptedAction: encAction,
      reason: res
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res2) => {
    if (res2.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.DocActionProcess,
        Result: res2.data
      });
    } else if (res2.status === 400 || res2.status === 401) {
      console.log("error: 401");
    }
  }).catch((res2) => {
    let errorMsg = res2.toString();
    if (errorMsg.includes("401")) {
      console.log("Unauthorized");
      Logout();
    }
  });
}
